export default __webpack_public_path__ + "static/media/t3.min.d3e1e2db.png";